import apiClient from "./index";
import {
  ManualBindingInfo,
  ManualBuildingOverview,
  ManualRegistrationToken,
  ManualSubmissionProgressSummaryResponse,
  ManualSubmissionProgressResponse,
  ManualTokenCreate,
} from "./types";

export const manualApi = {
  async getBuildingOverview(
    buildingId: string
  ): Promise<ManualBuildingOverview> {
    const response = await apiClient.get<ManualBuildingOverview>(
      `/manual/admin/buildings/${buildingId}/overview`
    );
    return response.data;
  },

  async createToken(
    payload: ManualTokenCreate
  ): Promise<ManualRegistrationToken> {
    const response = await apiClient.post<ManualRegistrationToken>(
      "/manual/admin/tokens",
      payload
    );
    return response.data;
  },

  async deleteToken(tokenId: string): Promise<void> {
    await apiClient.delete(`/manual/admin/tokens/${tokenId}`);
  },

  async revokeBinding(bindingId: string): Promise<ManualBindingInfo> {
    const response = await apiClient.post<ManualBindingInfo>(
      `/manual/admin/bindings/${bindingId}/revoke`
    );
    return response.data;
  },

  async getSubmissionProgress(
    buildingId: string,
    params?: {
      month?: string;
      source?: "ANY" | "TELEGRAM" | "IMPORT" | "STAFF_USB";
      corps_id?: string;
      system_type?: string[];
      include_details?: boolean;
    }
  ): Promise<ManualSubmissionProgressResponse> {
    const response = await apiClient.get<ManualSubmissionProgressResponse>(
      `/manual/admin/buildings/${buildingId}/submission-progress`,
      { params, paramsSerializer: { indexes: null } }
    );
    return response.data;
  },

  async getSubmissionProgressSummary(params: {
    year: number;
    month?: string;
    source?: "ANY" | "TELEGRAM" | "IMPORT" | "STAFF_USB";
    residential_complex_id?: string;
    current_only?: boolean;
  }): Promise<ManualSubmissionProgressSummaryResponse> {
    const response = await apiClient.get<ManualSubmissionProgressSummaryResponse>(
      "/manual/admin/submission-progress/summary",
      { params }
    );
    return response.data;
  },

};
